import React, { ChangeEvent, useState, useEffect } from "react";
import IcecastMetadataPlayer from "icecast-metadata-player";
import { useAppDispatch } from "../../../../../../hooks/redux-hooks";
import { setVolumePlayer } from "../../../../../../store/slices/main";
import "./style.css";
import VolumeWidget from "../../../../../../assets/icon/VolumeWidget";
import VolumeWidgetMute from "../../../../../../assets/icon/VolumeWidgetMute";

interface Props {
  player: IcecastMetadataPlayer;
  widthScreen: string;
  widthProgress: string;
  heightProgress: string;
}

const VolumeControl: React.FC<Props> = ({ player }) => {
  const dispatch = useAppDispatch();
  const savedVolume = Number(window.localStorage.getItem("volume"));
  const [volume, setVolume] = useState<number>(savedVolume);
  const [isMuted, setIsMuted] = useState<boolean>(false);
  const rootStyles = {
    "--track-background": `linear-gradient(to right, #fd8533 0%, #fd8533 ${volume}%, #D5D6DB ${volume}%, #D5D6DB 100%)`,
    "--thumb-background": "#fd8533",
  } as React.CSSProperties;

  useEffect(() => {
    setVolume(savedVolume || 50);
  }, [savedVolume]);

  const changeVolume = (value: number) => {
    setVolume(value);
    player.audioElement.volume = value / 100;

    document.documentElement.style.setProperty(
      "--track-background",
      `linear-gradient(to right, #fd8533 0%, #fd8533 ${value}%, #D5D6DB ${value}%, #D5D6DB 100%)`
    );
    document.documentElement.style.setProperty("--thumb-background", "#fd8533");
    dispatch(setVolumePlayer(value));

    setIsMuted(value === 0);
  };

  const handleClick = () => {
    if (isMuted) {
      changeVolume(savedVolume || 50);
    } else {
      setIsMuted(true);
      changeVolume(0);
    }
  };

  return (
    <div
      className="flex justify-center items-center w-full pb-2.5"
      style={rootStyles}
    >
      <div className="pr-2 pt-2.5">
        <div className="cursor-pointer" onClick={handleClick}>
          {isMuted ? <VolumeWidgetMute /> : <VolumeWidget />}
        </div>
      </div>
      <div className="min-w-[6rem]">
        <input
          id="$seekbar"
          type="range"
          min={1}
          max={100}
          value={volume}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            changeVolume(Number(e.target.value))
          }
        />
      </div>
      <div className="pl-5"></div>
    </div>
  );
};

export default VolumeControl;
